import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { Paper, makeStyles } from '@material-ui/core';
import exporting from 'highcharts/modules/exporting';

// Initialize the exporting module
exporting(Highcharts);

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
}));


const ReportGraph = ({ data, isEvent = false }) => {
    const classes = useStyles();


    const options = {
        chart: {
            type: 'column',
            zoomType: 'x',
            events: {
                load: function () {
                    const chart = this;

                    if (isEvent) {

                        // Set default view to show top 10 categories on initial load
                        chart.xAxis[0].setExtremes(0, 9);

                        // Add custom button for "Top 10"
                        chart.renderer.button('Top 10', 80, 10, function () {
                            chart.xAxis[0].setExtremes(0, 9); // Set zoom to show first 10 categories
                        }).add();

                        // Add custom button for "Top 50"
                        chart.renderer.button('Top 50', 150, 10, function () {
                            chart.xAxis[0].setExtremes(0, 49); // Set zoom to show first 50 categories
                        }).add();

                        // Add custom button for "Show All"
                        chart.renderer.button('Show All', 220, 10, function () {
                            chart.xAxis[0].setExtremes(null, null); // Reset zoom to show all categories
                        }).add();
                    }
                }
            }
        },
        title: {
            text: data.title
        },
        subtitle: {
            text: data.subtitle
        },
        xAxis: {
            categories: data.categories,
        },
        yAxis: {
            min: 0,
            title: {
                text: data.yAxis
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: 'black'
                }
            },
            labels: {
                formatter: function () {
                    return Highcharts.numberFormat(this.value, 0); // Shows full number format (1000, 2000, etc.)
                }
            }
        },
        legend: {
            enabled: true, // This will hide the legend (series labels)
        },
        tooltip: {
            headerFormat: '<b>{point.x}</b><br/>',
            pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        // plotOptions: {
        //     column: {
        //         grouping: true, // Ensure bars are grouped
        //         shadow: false, // Optional styling
        //         borderWidth: 0, // Optional styling
        //     },
        // },
        plotOptions: {
            column: {
                stacking: null, // Remove stacking to display individual bars
                grouping: true, // Ensure bars are grouped
                borderWidth: 0, // Optional styling
                dataLabels: {
                    enabled: true,
                    style: {
                        fontWeight: 'bold',
                        color: 'black',
                    },
                },
            },
        },
        series: data.series,

        // Enable exporting feature
        exporting: {
            enabled: true,
            buttons: {
                contextButton: {
                    menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
                }
            }
        },
        credits: {
            enabled: false
        },

    };

    return (
        <Paper className={classes.paper}>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </Paper>
    );
};

export default ReportGraph;
